'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Exists to trigger events on show shopping basket
// Use: wrap around the button that calls window.showShoppingBasket()
// Example
// <shopping-cart-button call="window.showShoppingBasket()">
//     <button ng-click="$parent.click()">Open</button>
// </shopping-cart-button>
// TODO: stop using window.showShoppingBasket()

var ShoppingCartButtonController = function () {
    function ShoppingCartButtonController($scope) {
        _classCallCheck(this, ShoppingCartButtonController);

        this.$scope = $scope;
    }

    _createClass(ShoppingCartButtonController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            if (!this.winresReservationContext) {
                if (window.definiteWinresReservationContext) {
                    console.log('[shopping-cart-button]', 'Context is not available. Falling back to global.');
                    this.winresReservationContext = window.definiteWinresReservationContext;
                } else {
                    throw new Error('A context is required.');
                }
            }

            this.data = this.winresReservationContext.getContext();

            this.$scope.click = function () {
                _this.winresReservationContext.dataLayerEvent('onOpenCart', _this.data.Products);
                _this.call({ 'window': window });
            };
        }
    }]);

    return ShoppingCartButtonController;
}();

ShoppingCartButtonController.$inject = ['$scope'];

_module3.default.component('shoppingCartButton', {
    template: '<ng-transclude></ng-transclude>',
    controller: ShoppingCartButtonController,
    require: {
        winresReservationContext: '?^^winresReservationContext'
    },
    bindings: {
        // function that triggers opening of the shopping cart, ex: window.showShoppingCart()
        call: '&'
    },
    transclude: true
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/shoppingCartButton/shoppingCartButton.js
// module id = 381
// module chunks = 2